import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://192.168.30.170:5001/api',
});

api.interceptors.request.use((config) => {
  let userInfo = null; try { userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null'); } catch (e) { localStorage.removeItem('userInfo'); }
  if (userInfo?.token) {
    config.headers.Authorization = `Bearer ${userInfo.token}`;
    const activeSchoolId = localStorage.getItem('activeSchoolId');
    if (userInfo.role === 'superadmin' && activeSchoolId) config.headers['X-School-Id'] = activeSchoolId;
  }
  return config;
});

export default api;